(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AdminClusterActionsIndividualsController', AdminClusterActionsIndividualsController);

    function AdminClusterActionsIndividualsController($scope, $state, $stateParams, $q, $translate, logger, skill, modalDialogService, notifyingService, dataService, skillService, jsReportService) {
        var vm = this;
        var _lazyLoadQualities = _.debounce(loadQualities, 300);

        vm.item = skill.item;
        vm.changeVector = skill.changeVector;
        
        vm.gridOptions = {
            enableFiltering: true,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('employee'),
                    name: 'employeeName',
                    enableColumnMenu: false
                },
                {
                    displayName: $translate.instant('progress'),
                    name: 'progress',
                    cellTemplate: '/app/templates/common/userquality-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    width: 150,
                    enableFiltering: false
                },
                {
                    displayName: $translate.instant('expiry_date'),
                    name: 'dateOfExpiry',
                    cellTemplate: '/app/templates/common/date-of-expiry-cell.tpl.html',
                    width: 150,
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/clusteractions/individuals-grid-buttons.tpl.html',
                    width: 100,
                    minWidth: 100,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.addUsers = addUsers;
        vm.back = back;
        vm.deleteIndividualQuality = deleteIndividualQuality;
        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.editIndividualQuality = editIndividualQuality;
        vm.editSkill = editSkill;
        vm.isCurrentState = isCurrentState;
        vm.loadQualities = loadQualities;


        $scope.$watch('vm.changeVector', function (n, o) {
            if (n === o) return;
            logger.log('vm.changeVector: ' + n);

            dataService.getSkill(vm.item.id).then(result => {
                vm.item = result.item;
                vm.changeVector = result.changeVector;
                loadQualities();
            });
        });
        
        notifyingService.subscribe($scope, 'skill-updated', function (event, args) {
            if (args.id !== vm.item.id) return;
            angular.copy(args, vm.item);
        });

        notifyingService.subscribe($scope, 'userquality-updated', function (event, args) {
            if (!vm.selectedUserQuality) return;
            if (args.id !== vm.selectedUserQuality.id) return;
            loadQualities();
        });

        _initialize();

        function _downloadReport(type) {
            var reportInfo = {
                actionName: vm.item.actionName,
                clusterName: vm.item.clusterName,
                validity: vm.item.validity
            };

            var items = vm.gridOptions.data;

            return jsReportService.getClusterActionsIndividualsUserQualitiesReport(type, reportInfo, items);
        }

        function _initialize() {
            loadQualities();
        }

        function addUsers() {
            modalDialogService.openAddIndividualsDialog().then(identities => {
                var idStrings = identities.map(identity => identity.idString);
                return skillService.assignSkillToUsers(vm.item.id, idStrings);
            }).then(qualities => {
                logger.success('successfully_saved');
                var allItems = _.union([], vm.gridOptions.data, qualities);
                vm.gridOptions.data = _.chain(allItems)
                    .sortBy(user => { return user.employeeName.toLowerCase(); })
                    .uniq('id')
                    .value();
                vm.gridOptions.gridApi.core.handleWindowResize();
            });
        }

        function back() {
            $state.go('^');
        }

        function deleteIndividualQuality(entity) {
            modalDialogService.confirmDelete('delete_individual_quality', 'confirm_delete_individual_quality', () => {
                dataService.deleteUserQuality(entity.id)
                    .then(result => {
                        logger.success('successfully_deleted');
                        var index = vm.gridOptions.data.indexOf(entity);
                        vm.gridOptions.data.splice(index, 1);
                    });
            });
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function editIndividualQuality(entity) {
            vm.selectedUserQuality = entity;
            $state.go('app-main.admin-clusteractions.individuals.userquality', { id: entity.id });
        }

        function editSkill() {
            $state.go('app-main.admin-clusteractions.individuals.edit-skill', { id: vm.item.id });
        }

        function isCurrentState() {
            return $state.is('app-main.admin-clusteractions.individuals');
        }

        function loadQualities() {
            vm.gridOptions.data = [];
                        
            dataService.getIndividualUserQualitiesForAdmin({ skillId: vm.item.id }).then(userQualities => {
                vm.gridOptions.data = userQualities;
                vm.gridOptions.gridApi.core.handleWindowResize();
            });
        }
    }
})();